import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index";

Vue.use(VueRouter);

// * router에 연결된 .vue 파일은 src/views 폴더 아래.
// * 재사용이 가능하며 다른 vue 파일에 import에 의해 사용되는 .vue 파일은 src/components 폴더 아래.
const routes = [

    // * Auth 관련
    // * -> 로그인, 회원가입, 이메일 찾기, 비밀번호 찾기, 비밀번호 재설정
    {
        path: "/",
        name: "login",
        component: () => import("../views/authentication/Login.vue")
    },
    {
        path: "/register",
        name: "register",
        component: () => import("../views/authentication/Register.vue")
    },
    {
        path: "/find/id",
        name: "findId",
        component: () => import("../views/authentication/FindId.vue")
    },
    {
        path: "/find/pw",
        name: "findPw",
        component: () => import("../views/authentication/FindPw.vue")
    },
    {
        path: "/find/pw/reset",
        name: "findPwReset",
        component: () => import("../views/authentication/FindPwReset.vue")
    },

    // * 로그인 후, Admin 페이지 관련
    {
        path: "/",
        name: "adminWrapper",
        component: () => import("../views/wrapper/AdminWrapper.vue"),

        meta: { requireLogin: true },
        /**
         * * 사용자 정의 메타 데이터
         * * 상위 라우트 meta 속성에 값을 정의하면 라우트 가드에서 to.matched 접근 시, 하위에 있는 route에서도 상위 meta 속성에 접근 가능.
         * * ex) /kosiwon/list 접근 시, to.matched
         * * 상위 "/"(adminWrapper)와 하위 "/kosiwon/list"(kosiwonList) 라우트 정보들을 모두 배열 형태로 담고 있음 -> 최상위 라우터 meta 정보에 로그인이 필요한 페이지 여부 넣어주면 됨
         */
        children: [
            {
                path: "/kosiwon/list",
                name: "kosiwonList",
                component: () => import("../views/kosiwon/KosiwonList.vue")
            },
            {
                path: "/room/list",
                name: "roomList",
                component: () => import("../views/kosiwon/RoomList.vue")
            },
            {
                path: "/guest/status",
                name: "guestStatus",
                component: () => import("../views/kosiwon/GuestStatus.vue")
            },
            {
                path: "/guest/list",
                name: "guestList",
                component: () => import("../views/kosiwon/GuestList.vue")
            },
            {
                path: "/kosiwon/register/:id?",
                name: "kosiwonRegister",
                component: () => import("../views/kosiwon/KosiwonRegister.vue")
            },
            {
                path: "/notice/list",
                name: "noticeList",
                component: () => import("../views/NoticeList.vue")
            },
            {
                path: "/notification",
                name: "notification",
                component: () => import("../views/Notification.vue")
            },
            {
                path: "/faq",
                name: "faq",
                component: () => import("../views/Faq.vue")
            },
            {
                path: "/product",
                name: "product",
                component: () => import("../views/Product.vue")
            },
            {
                path: "/mypage",
                name: "mypage",
                component: () => import("../views/Mypage.vue")
            }
        ]
    },

    // * 유지보수 page
    {
        path: "/maintenance",
        name: "maintenance",
        component: () => import("../views/Maintenance.vue")
    },

    // * 404 page
    {
        path: "*",
        name: "404",
        component: () => import("../views/404.vue")
    }
];

const router = new VueRouter({
    mode: "hash",	// hash(default) or history
    base: process.env.BASE_URL,
    routes
});

// * 전역 route guard
// * router에서 페이지로 넘어가기전 실행되는 Hook
router.beforeEach((to, from, next) => {
    // ? some 함수 : 특정 조건에서 하나라도 맞으면 더이상 배열을 순회하지 않고 true 반환, 하나도 없으면 false
    const isAuthPage = to.matched.some(record => record.meta.requireLogin); // 로그인이 필요한 페이지인지에 대한 여부
    const isLogin = store.getters.isLoggedIn;   // 로그인 상태 체크 여부

    if (to.path === "/" && isLogin) {   // * CASE_1 : 로그인 페이지 접근 시, 이미 로그인이 되어 있다면 특정 페이지로 이동 (대쉬보드)
        next("/kosiwon/list");
    } else if (isAuthPage && !isLogin) {    // * CASE_2 : 로그인이 필요한 페이지(private) 접근 시, 로그인이 되어 있지 않다면 로그인 페이지로 이동
        next("/")
    } else {    // * CASE_3 : 정상적인 경우 해당 path로 이동
        next();
    }
});

// * router에서 페이지 이동이 완료된 후 실행되는 Hook
// * Vue components에서 beforeCreate() 함수보다 먼저 실행됨, this 접근 불가
router.afterEach(() => {
    window.scrollTo(0, 0);
});

export default router;